import React from 'react';

const Hero: React.FC = () => {
  const handleContactClick = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleServicesClick = () => {
    const element = document.querySelector('#services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-surface via-surface-soft to-surface">
      {/* Animated Grid Background */}
      <div className="grid-bg"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 gradient-text">
          Leading IT Consulting & Software Development in Vietnam & Southeast Asia
        </h1>
        
        <p className="text-lg sm:text-xl text-ink-500 mb-8 max-w-3xl mx-auto leading-relaxed">
          We deliver cutting-edge software development, IT consulting, and AI solutions to transform businesses across Vietnam and Southeast Asia. 3B Consulting - Your trusted technology partner in the region.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button
            onClick={handleContactClick}
            className="btn-primary"
          >
            Contact Us
          </button>
          <button
            onClick={handleServicesClick}
            className="btn-secondary"
          >
            View Services
          </button>
        </div>
        
        {/* Energy Bar */}
        <div className="energy-bar mx-auto"></div>
      </div>
    </section>
  );
};

export default Hero; 